import { PaginatedApiResponse } from '@/types/api.types';

export interface NotificationSettingsModule {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface NotificationSettingsModuleListResponse
  extends PaginatedApiResponse<NotificationSettingsModule[]> {
  status: boolean;
  message: string;
}

export interface NotificationRule {
  id: string;
  rule_name: string;
  user_roles_involved: { user_type: number; is_enabled: boolean }[];
  notification_rule_type: number;
  is_rule_enabled: boolean;
  is_email_notification_configured: boolean;
  is_push_notification_configured: boolean;
  is_email_notification_enabled: boolean;
  is_push_notification_enabled: boolean;
  email_template_id: string | null;
  notification_template_id: string | null;
  email_template: unknown | null;
  notification_template: unknown | null;
  changed_by_id: string | null;
  changed_by_user: {
    id: string;
    name: string;
  } | null;
  changed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface NotificationRulesResponse
  extends PaginatedApiResponse<NotificationRule[]> {
  status: boolean;
  message: string;
}

export enum NotificationUserRoles {
  ADMIN = 1,
  COMMUNITY_MEMBERS = 2,
  MENTIONED_USERS = 3,
  SUBSCRIBED_USER = 4,
  POI_REQUEST_USER = 5,
  HARBOUR_REQUESTING_USER = 6,
  CLUB_MEMBER = 7,
  BOATER = 8,
  CLUB_MEMBER_REQUESTING_USER = 9,
  CLUB_REQUESTER = 10,
  HARBOUR_MANAGER = 11,
  REGIONAL_OPERATOR = 12,
  YACHT_CLUB_ADMIN = 13,
  MARINA_MANAGER = 14,
  SERVICE_PROVIDER = 15,
  USER = 16,
}
